import { ClientEmployeeFragment } from "@graphql/client-employees/clientEmployees.g";

import { CreateClientEmployeeForm } from "@components/Forms";

import { Card } from "@design-system/Card/Card";

type Props = {
  clientId: string;
  onCreateClientEmployeeSuccess?: (
    data: ClientEmployeeFragment,
  ) => Promise<void> | void;
};

export const CreateClientEmployeeCard = ({
  clientId,
  onCreateClientEmployeeSuccess,
}: Props) => {
  return (
    <Card>
      <Card.Header>
        <Card.Header.Title>Create user</Card.Header.Title>
      </Card.Header>
      <Card.Body>
        <CreateClientEmployeeForm
          clientId={clientId}
          onCreateClientEmployeeSuccess={onCreateClientEmployeeSuccess}
        />
      </Card.Body>
    </Card>
  );
};
